/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_K_DeveloperInputs */

const en_home_artcraft_k_developer = /** @type {(inputs: Home_Artcraft_K_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Home_Artcraft_K_DeveloperInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_k_developer = /** @type {((inputs?: Home_Artcraft_K_DeveloperInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_K_DeveloperInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_k_developer(inputs)
});
export { home_artcraft_k_developer as "home.artcraft.k_developer" }